import React from "react";
import Button from "../inputs/Button";
import Badge from "../shared/Badge";
import Card from "../shared/Card";

const FinalReportSection = ({ status, finalReport, onUpload }) => {
  if (
    status !== "DECISION_REACHED" &&
    status !== "PENDING_PUBLICATION" &&
    status !== "PUBLISHED"
  ) {
    return null;
  }

  const getStatusVariant = (reportStatus) => {
    const variants = {
      APPROVED: "success",
      PENDING_REVIEW: "warning",
    };
    return variants[reportStatus] || "default";
  };

  return (
    <Card
      title="Final Report"
      headerAction={
        !finalReport && status === "DECISION_REACHED" ? (
          <Button variant="primary" size="sm" onClick={onUpload}>
            Share Final Report
          </Button>
        ) : null
      }
    >
      {finalReport ? (
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="flex items-start justify-between">
            <div className="flex items-start flex-1">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                <svg
                  className="w-7 h-7 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-gray-900">
                  {finalReport.name}
                </h4>
                <p className="text-sm text-gray-600 mt-1">
                  {finalReport.summary}
                </p>
                <div className="flex items-center space-x-4 mt-3 text-sm text-gray-500">
                  {finalReport.type && <span>{finalReport.type}</span>}
                  {finalReport.size && <span>{finalReport.size}</span>}
                  <span>Uploaded {finalReport.uploadDate}</span>
                </div>
              </div>
            </div>
            {finalReport.status && (
              <Badge
                variant={getStatusVariant(finalReport.status)}
                size="sm"
                className="ml-4"
              >
                {finalReport.status.replace("_", " ")}
              </Badge>
            )}
          </div>
          <div className="mt-4 flex space-x-3">
            <Button variant="primary" size="sm">
              Preview Report
            </Button>
            <Button variant="outline" size="sm">
              Download PDF
            </Button>
          </div>
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <svg
            className="w-12 h-12 text-gray-400 mx-auto mb-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <p>No final report uploaded yet.</p>
          {status === "DECISION_REACHED" && (
            <button
              onClick={onUpload}
              className="mt-3 text-custom-blue hover:text-custom-light-blue font-medium text-sm"
            >
              Upload Final Report
            </button>
          )}
        </div>
      )}
    </Card>
  );
};

export default FinalReportSection;
